<div
  class="gatewee-wrapper gw-flex gw-flex-col gw-h-screen gw-overflow-hidden gw-bg-background-base"
>
  <gatewee-header
    [config]="getEffectiveHeaderConfig()"
    [isNavigationCollapsed]="isNavigationCollapsed()"
    (navigationToggle)="onNavigationToggle($event)"
  ></gatewee-header>

  <div class="gatewee-wrapper-content gw-flex gw-flex-1 gw-overflow-hidden">
    <gatewee-navigation
      [config]="getEffectiveNavigationConfig()"
      [isCollapsed]="isNavigationCollapsed()"
      (closeSideMenuMobile)="closeMobileMenu()"
      (navigationToggle)="onNavigationToggle($event)"
    ></gatewee-navigation>

    <main
      class="gatewee-main-content gw-flex-1 gw-overflow-y-auto gw-overflow-x-hidden gw-px-4 md:gw-px-6 xl:gw-px-8"
    >
      <div class="gw-w-full gw-max-w-[1600px] gw-mx-auto">
        <ng-content></ng-content>
      </div>
    </main>
  </div>
</div>
